import type { Feature } from '@luna/gatekeeper';

export const creditCardReissueExternal: Feature = {
    enabled: false,
    _description: 'Enables external card reissue section under services',
};
